export default {
  title: 'Update Event',
  backButton: 'Back to Events',
};
